import { TextField } from '@material-ui/core';
import { useLoginInfo } from '../../Hooks/useLoginInfo';
import { memo } from 'react';

export const TextBox = (props) => {
    const { forceEditable, ...rest } = props;
    let { isReadOnlyUser } = useLoginInfo();
    forceEditable && (isReadOnlyUser = false);
    return <TextField size="small" variant="outlined" disabled={isReadOnlyUser} autoComplete="off" {...rest} onWheel={(e) => e.target.blur()} fullWidth />;
};
export const FocusTextBox = (props) => {
    const { forceEditable, ...rest } = props;
    let { isReadOnlyUser } = useLoginInfo();
    forceEditable && (isReadOnlyUser = false);
    return (
        <TextField
            size="small"
            variant="outlined"
            disabled={isReadOnlyUser}
            autoComplete="off"
            {...rest}
            onWheel={(e) => e.target.blur()}
            fullWidth
            autoFocus
        />
    );
};

const InputTextWithMemo = memo(TextBox);
export default InputTextWithMemo;
